import {useDebugValue} from 'react';

import {undef} from '../../../utils/undef';
import {hasDatesDayTemplateComponent} from '../../../utils/dates';
import {runDatePickerSelectDateHintExperiment, runDatesAndNumberOfNightsExperiment} from '../../../utils/experiments';

import {SearchStandardDay} from '../../SearchStandardDay/SearchStandardDay';
import {SearchSelectDateHintDay} from '../../SearchSelectDateHintDay/SearchSelectDateHintDay';
import SearchDayAlertNightCount from '../../SearchDayAlertNightCount/SearchDayAlertNightCount';

import {useOptions} from './useOptions';

const defaultDatesOptions = {
    actionLocation: undef,
    alertTemplateComponent: undef,
    alertTemplateData: undef,
    allowErrorHighlighting: undef,
    autoProgress: undef,
    centered: undef,
    consolidateInputs: undef,
    dateFormatOptions: {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    },
    dayTemplateComponent: SearchStandardDay,
    disableTextInput: undef,
    displayYearFirst: undef,
    enableSameDayDateRange: undef,
    fadeOut: false,
    fadeOutDuration: 0,
    id: 'dates',
    inputIcon1Name: 'check-in',
    inputIcon2Name: 'check-out',
    inputName1: 'check-in',
    inputName2: 'check-out',
    maxDate: undef,
    minDate: undef,
    parentNode: undef,
    placement: undef,
    positionIconRight: undef,
    scrollNode: undef,
    showArrow: false,
    showInputIcon1: undef,
    showInputIcon2: undef,
    splitInputs: undef,
    wdioPrefix: undef
};

function useDatesOptions(props, abacusStore) {
    const {
        datesOptions: propsDatesOptions
    } = props;

    const shouldRunDatesAndNumberOfNightsExperiment = runDatesAndNumberOfNightsExperiment({shouldLogExperiment: false}, abacusStore);

    const experimentDatesOptions = {
        dayTemplateComponent: (
            !hasDatesDayTemplateComponent(propsDatesOptions) &&
            runDatePickerSelectDateHintExperiment({shouldLogExperiment: false}, abacusStore)
                ? SearchSelectDateHintDay
                : undef
        ),
        alertTemplateComponent: shouldRunDatesAndNumberOfNightsExperiment
            ? SearchDayAlertNightCount
            : undef,

        alertTemplateData: shouldRunDatesAndNumberOfNightsExperiment
            ? {endDate: null}
            : undef
    };

    const {
        options: datesOptions
    } = useOptions(defaultDatesOptions, experimentDatesOptions, propsDatesOptions);

    const result = {
        datesOptions
    };

    useDebugValue(result);

    return result;
}

export {useDatesOptions};
